import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import {
  AddCartPageModule,
  CancelPromoPageModule,
  CartWithoutStockPageModule,
  ConfirmCancelPageModule,
  ContinueResetPageModule,
  DailyRewardPageModule,
  DataRegistersPageModule,
  DeleteProductCartPageModule,
  FavoritosInfoModalModule,
  HowDoesWorkPageModule,
  InfoSheetModalPageModule,
  LeavePromoDetailPageModule,
  LegalChangePageModule,
  LifelessPageModule,
  LimitCountersPageModule,
  MaxDiscountsLimitPageModule,
  NewSectionGamePageModule,
  OrderProgressPageModule,
  PhoneRegisterPageModule,
  PromoDetailPageModule,
  PromoInfoModalPageModule,
  PromoSummaryModalPageModule,
  PromotionPageModule,
  PurchaseProgressPageModule,
  ReceivedLifePageModule,
  ResetUserPageModule,
  ResulExePushPageModule,
  RewardModalPageModule,
  SpamCartPageModule,
  SpamMoreProductsPageModule,
  SuccessResetPageModule,
  TimeoutEditPageModule,
  UserTicketPageModule,
  ZoomImageFullScreenPageModule,
} from './index.modals';


/** MODULES MODALS */
/** PAGE MODALS */

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    /** MODULES MODALS */
    HowDoesWorkPageModule,
    ResetUserPageModule,
    CancelPromoPageModule,
    SpamCartPageModule,
    LifelessPageModule,
    ReceivedLifePageModule,
    LegalChangePageModule,
    DailyRewardPageModule,
    NewSectionGamePageModule,
    ConfirmCancelPageModule,
    ResulExePushPageModule,
    PromoDetailPageModule,
    AddCartPageModule,
    PurchaseProgressPageModule,
    OrderProgressPageModule,
    ContinueResetPageModule,
    UserTicketPageModule,
    SuccessResetPageModule,
    TimeoutEditPageModule,
    SpamMoreProductsPageModule,
    DataRegistersPageModule,
    DeleteProductCartPageModule,
    FavoritosInfoModalModule,
    PhoneRegisterPageModule,
    LimitCountersPageModule,
    PromotionPageModule,
    InfoSheetModalPageModule,
    PromoSummaryModalPageModule,
    PromoInfoModalPageModule,
    RewardModalPageModule,
    MaxDiscountsLimitPageModule,
    LeavePromoDetailPageModule,
    CartWithoutStockPageModule,
    ZoomImageFullScreenPageModule,
  ],
  exports: [
    TranslateModule,
  ]
})
export class ModalsModule { }
